import React from 'react';
import { Flex, Button, Popconfirm } from 'antd';
import AssessmentActions from './AssessmentActions';
import { isIdCheckProduct } from '../../../../utils/idCheckStatus';

const FILTER_PREFIXES = [
  'thank you for your order.',
  'thank you for your order!',
];

function filterEbayMessage(content) {
  if (!content) return content;
  const lower = content.toLowerCase();
  for (const prefix of FILTER_PREFIXES) {
    if (lower.startsWith(prefix)) {
      return content.slice(prefix.length).trimStart();
    }
  }
  return content;
}

const ProductAssessmentItem = ({
  proAssess,
  idCheckSummary,
  index,
  assessment,
  order,
  approvedPro,
  cancelledPro,
  pendingPro = [],
  canApprove,
  canDecline,
  canMarkPending,
  markProductPending,
  confirmApprove,
  showCancelModal,
  openAssessmentActionModal
}) => {
  const productId = String(proAssess.productId ?? "");
  const approvedIds = approvedPro.map((id) => String(id));
  const cancelledIds = cancelledPro.map((id) => String(id));
  const pendingIds = pendingPro.map((id) => String(id));
  const orderProduct = order?.products?.find(
    p => p.productMongoId === proAssess.productId?.toString()
  );
  // Driven by the ID-check summary, so it survives an order refresh from
  // another endpoint (approve, decline, status change).
  const requiresIdCheck = isIdCheckProduct(idCheckSummary, orderProduct?.sku);

  const rawEbayMessage = orderProduct?.ebayMessageContent;
  const isValidEbayMessage =
    rawEbayMessage &&
    rawEbayMessage !== 'undefined' &&
    rawEbayMessage.trim() !== '';

  const showEbayMessage =
    order?.isPGD &&
    assessment?.status === 'PENDING' &&
    isValidEbayMessage;

  const ebayMessageFiltered = showEbayMessage
    ? filterEbayMessage(rawEbayMessage)
    : null;

  return (
    <div className="accordion accordion-flush" id="accordionFlushExample">
      <div className="accordion-item mb-4">
        <h2 className="accordion-header" id={`flush-heading-${index}`}>
          <button
            className={`accordion-button ${
              assessment.status === "PENDING" ? "collapsed" : ""
            }`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#flush-collapse-${index}`}
            aria-expanded={assessment.status !== "PENDING"}
            aria-controls={`flush-collapse-${index}`}
          >
            {proAssess.productName}
            {requiresIdCheck && (
              <span className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle ms-2">
                <i className="fas fa-id-card me-1" aria-hidden="true" />
                ID check
              </span>
            )}
          </button>
        </h2>
        <div
          id={`flush-collapse-${index}`}
          className={`accordion-collapse collapse ${
            assessment.status === "PENDING" ? "" : "show"
          }`}
          aria-labelledby={`flush-heading-${index}`}
          data-bs-parent="#accordionFlushExample"
        >
          <div className="accordion-body">
            {showEbayMessage ? (
              <p style={{ whiteSpace: 'pre-wrap', fontSize: '13px' }}>
                {ebayMessageFiltered}
              </p>
            ) : (
              proAssess.questions?.map((res, key) => (
                <QuestionResponse key={res.id || key} question={res} />
              ))
            )}

            {/* Approval Actions */}
            {!assessment.isReview &&
              (order.status === "PENDING" ||
                order.status === "PENDING_REVIEW" ||
                order.status === "ASSESSMENT_REQUIRED" ||
                order.status === "PRIME_READY" ||
                order.status === "TO_CANCEL" ||
                assessment.status === "PENDING") &&
              !approvedIds.includes(productId) &&
              !cancelledIds.includes(productId) &&
              !pendingIds.includes(productId) && (
                <AssessmentActions
                  proAssess={proAssess}
                  approvedPro={approvedPro}
                  cancelledPro={cancelledPro}
                  pendingPro={pendingPro}
                  canApprove={canApprove}
                  canDecline={canDecline}
                  canMarkPending={canMarkPending}
                  markProductPending={markProductPending}
                  order={order}
                  assessment={assessment}
                  openAssessmentActionModal={openAssessmentActionModal}
                />
            )}

            {assessment.isReview && (
              <>
              <div className=''>
                <p className={`${proAssess.isCancel ? 'text-danger':'text-primary'}`} style={{fontSize:'15px', fontWeight:'700'}}>{proAssess?.motive?.title}</p>
                <p className="text-dark">{proAssess?.motive?.note}</p>
              </div>

              </>
            )}

            {/* Status Indicators */}
            {approvedIds.includes(productId) && (
              <span className="text-primary">Product Approved</span>
            )}
            {cancelledIds.includes(productId) && (
              <span className="text-danger">Product Cancelled</span>
            )}
            {pendingIds.includes(productId) && (
              <span className="text-warning">Product Pending</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const QuestionResponse = ({ question }) => (
  <div>
    <div className="col-lg-12">
      <div className="d-flex align-items-center gap-3">
        <div className="w-100">
          <label className="pb-1 text-black m-3" style={{ fontSize: "12px" }}>
            {question.title}
            {question.description && (
              <>
                <br />
                <span
                  className="question-desc"
                  dangerouslySetInnerHTML={{ __html: question.description }}
                />
              </>
            )}
          </label>
        </div>
      </div>
    </div>
    <div className="col-lg-12">
      {question.response && (
        <ResponseDisplay question={question} response={question.response} />
      )}
    </div>
  </div>
);

const ResponseDisplay = ({ question, response }) => {
  const isCorrect = 
    question.type !== "textarea" &&
    (!question.correctAnswer || 
     question.correctAnswer.trim().toLowerCase() === response.trim().toLowerCase());

  return (
    <div className="d-flex align-items-center gap-2 justify-content-end">
      <div className={`right-block-box text-white fs-14 ${isCorrect ? "bg-success" : ""}`}>
        {response}
      </div>
    </div>
  );
};

export default ProductAssessmentItem;
